export default function sprintf(format: string, ...args: any[]): string {
    let i = 0;
    return format.replace(/%[sdif]/g, (match) => {
        let val = args[i++];
        switch (match) {
            case "%d": return parseInt(val, 10).toString();
            case "%f": return parseFloat(val).toString();
            case "%i": return parseInt(val, 10).toString();
            case "%s": return String(val);
            default: return match;
        }
    });
}